module.exports = __webpack_public_path__ + "static/media/template-icon-dark.b70722fc.svg";